import { createAction } from "@reduxjs/toolkit";
export const FETCH_DOMAIN_INFO = 'FETCH_DOMAIN_INFO';
export const fetchDomainInfoAction = createAction(FETCH_DOMAIN_INFO);